// Public address of the site. Must match the sitemap (backend SitemapController.BASE_URL)
// and the Search Console property, so canonical URLs and sitemap URLs are identical.
export const SITE_URL = 'https://www.placeyourjob.com';

/** Job offers use the same URL as the sitemap; seeking posts need the type. */
export const detailsPathFor = (id, seek) => `/details?id=${id}${seek ? '&type=seek' : ''}`;
